import { Pagination as PaginationContainer, PaginationPage } from '@pocketlaw/tetris';
import { usePagination } from './utils/usePagination';
export function Pagination(props) {
    const { limit, count, offset, setOffset } = props;
    const { totalPages, pages, prev, next } = usePagination({
        count,
        limit,
        offset,
        setOffset,
    });
    if (totalPages < 2) {
        return null;
    }
    return (<PaginationContainer prev={prev} next={next}>
      {pages.map(({ value, pageNumber }) => (<PaginationPage key={value} $selected={offset === value} onClick={() => setOffset(value)}>
          {pageNumber}
        </PaginationPage>))}
    </PaginationContainer>);
}
